import {PropTypes} from 'react'

export default PropTypes



// WEBPACK FOOTER //
// ./src/types.js